import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
    Checkbox,
    FormControlLabel,
    Typography,
    Box
} from '@mui/material';
import { Button, TextField, Backdrop, CircularProgress } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataRH } from "../../../data/modules/hr-header";
import { useNavigate, useParams } from 'react-router-dom';
import TimeTrackingService from "../../../services/TimeTrackingService";
import Message from "../../tools/Message";
import { LoadingButton } from '@mui/lab';
import Autocomplete from '@mui/material/Autocomplete';

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: "flex",
        overflow: "auto",
        flexDirection: "column",
        elevation: 0,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
}));

export default function TimeTrackingAdd(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    const params = useParams();
    const idtime = params.id;
    
    
    const [form, setForm] = useState({
        id: '',
        date: '',
        observation: '',
        morning: {
            active: false,
            entryTime: '',
        },
        afternoon: {
            active: false,
            exitTime: ''
        }
    });
    
    const [isvalidate, setIsvalidate] = useState(true);
    const [isLoading, setIsLoading] = useState(false); 
    const [initialLoading, setInitialLoading] = useState(false);
    const [message, setMessage] = useState({
        open: false,
        color: 'green',
        messageInfo: '',
    });
    
    const { open, color, messageInfo } = message;

    const handlePeriodChange = (period) => (e) => {
        const { checked } = e.target;
        setForm(prevState => ({
            ...prevState,
            [period]: {
                ...prevState[period],
                active: checked
            }
        }));
    };

    const handleTimeChange = (period, field) => (e) => {
        const { value } = e.target;
        setForm(prevState => ({
            ...prevState,
            [period]: {
                ...prevState[period],
                [field]: value
            }
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const dateAujourdui = new Date(); 
        const dateValue = new Date(value);
    
        if (name === "date" && dateValue > dateAujourdui) {
            setMessage({
                ...message,
                open: true,
                color: 'red',
                messageInfo: "La date doit être inférieure ou égale à aujourd'hui"
            });
            setIsvalidate(true);
        } else {
            setIsvalidate(false);
            setForm(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };
    
    const handleClick = () => {
        if (form.date === '' || form.observation === '') {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: "Veuillez compléter le motif."
            });
            return;
        }
        
        if (!form.morning.active && !form.afternoon.active) {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: "Veuillez sélectionner au moins une période."
            });
            return;
        }
        
        const errors = [];
        
        // if (form.morning.active) {
        //     if (!form.morning.entryTime) errors.push("Heure d'entrée matin manquante");
        // }
        
        // if (form.afternoon.active) {
        //     if (!form.afternoon.exitTime) errors.push("Heure de sortie après-midi manquante");
        // }
        
        if (errors.length > 0) {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: errors.join(", ")
            });
            return;
        }
        
        const payload = {
            ...form,
            date: form.date,
            observation: form.observation
        };
        
        setIsLoading(true);
        
        if (form.id !== '') {
            TimeTrackingService.updateTimePrevisionaly(idtime, payload)
                .then(handleApiResponse)
                .catch(handleApiError);
        } else {
            TimeTrackingService.setTimePrevisionaly(payload)
                .then(handleApiResponse)
                .catch(handleApiError);
        }
    };

    const handleApiResponse = (results) => {
        if (results) {
            setMessage({
                ...message, 
                open: true, 
                color: 'green', 
                messageInfo: results.message
            });
            setTimeout(() => {
                navigate('/timeTrackingprovisional');
            }, 1500);
        } else {
            setMessage({
                ...message, 
                open: true, 
                color: 'red', 
                messageInfo: results?.message || "Une erreur est survenue"
            });
        }
        setIsLoading(false);
    };

    const handleApiError = (error) => {
        setMessage({
            ...message,
            open: true,
            color: 'red',
            messageInfo: error.message || "Erreur lors de la communication avec le serveur"
        });
        setIsLoading(false);
    };

    const handleCloseMessage = () => {
        setMessage({...message, open: false});
    };
    
    const formatDate = (dateString) => {
        if (!dateString) return '';
        
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
        
        return date.toISOString().split('T')[0];  
    };


    useEffect(() => {
        if (idtime) {
            setInitialLoading(true);
            TimeTrackingService.getByIDTimePrevisionaly(idtime)
                .then((results) => {
                    if (results && results.data) {
                        setIsvalidate(false);
                        const data = results.data;
                        
                        setForm({
                            id: data.timetraking_id,
                            date: formatDate(data.timetraking_date),
                            observation: data.observation,
                            morning: {
                                active: data.timetracking_entree !== null ,
                                entryTime: data.timetracking_entree || '',
                               // exitTime: data.timetracking_morning_exit || ''
                            },
                            afternoon: {
                                active: data.timetracking_sortieap !== null,
                              //  entryTime: data.timetracking_afternoon_entry || '',
                                exitTime: data.timetracking_sortieap || ''
                            }
                        });
                    }
                })
                .catch(handleApiError)
                .finally(() => setInitialLoading(false));
        }
    }, [idtime]);

    return (
        <MainContainer {...headerDataRH}>
            <Backdrop className={classes.backdrop} open={initialLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            
            <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
            
            <Paper style={{ padding: 20 }}>
                <Grid container spacing={3}>
                    {/* Champ Date */}
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Date * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="date"
                            onChange={handleChange}
                            value={form.date}
                            type="date"
                            disabled={initialLoading}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    
                    {/* Sélection des périodes */}
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Périodes * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={form.morning.active}
                                            onChange={handlePeriodChange('morning')}
                                            color="primary"
                                        />
                                    }
                                    label="Entrée"
                                />
                                {/* {form.morning.active && (
                                    <Box mt={2} ml={4}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    label="Heure d'entrée"
                                                    type="time"
                                                    //value={form.morning.entryTime}
                                                    onChange={handleTimeChange('morning', 'entryTime')}
                                                    value={form.morning.entryTime ? form.morning.entryTime.substring(0, 5) : ''}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )} */}
                            </Grid>
                            
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={form.afternoon.active}
                                            onChange={handlePeriodChange('afternoon')}
                                            color="primary"
                                        />
                                    }
                                    label="Sortie"
                                />
                                {/* {form.afternoon.active && (
                                    <Box mt={2} ml={4}>
                                        <Grid container spacing={2}>
                                             <Grid item xs={12}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    variant="outlined"
                                                    label="Heure de sortie"
                                                    type="time"
                                                    value={form.afternoon.exitTime ? form.afternoon.exitTime.substring(0, 5) : ''}
                                                    onChange={handleTimeChange('afternoon', 'exitTime')}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                )} */}
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    {/* Champ Motif */}
                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <label>Motif * :</label>
                    </Grid>
                    <Grid item xs={8}>
                        <TextField
                            fullWidth
                            size="small"
                            variant="outlined"
                            name="observation"
                            value={form.observation}
                            onChange={handleChange}
                            multiline
                            rows={3}
                            disabled={initialLoading}
                        />
                    </Grid>
                    
                    {/* Bouton Enregistrer */}
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                        <LoadingButton
                            loading={isLoading} 
                            loadingPosition="center" 
                            variant="contained"
                            color="primary"
                            onClick={handleClick}
                            style={{ fontWeight: 600 }}
                            disabled={isvalidate || isLoading || initialLoading}
                            fullWidth
                        >
                            ENREGISTRER
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Paper>
        </MainContainer>
    );
}